export default async function GetFilteredPlanAttributesApi(
  name,
  valueType,
  status,
  page,
  LIMIT_PER_PAGE
) {
  let res = "";
  try {
    const token = "Bearer " + localStorage.getItem("authToken");
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: token,
      },
    };
    await fetch(
      `${process.env.REACT_APP_API_URL}v1/plan-attributes/filter?name=${name}&valueType=${valueType}&status=${status}&page=${page}&limit=${LIMIT_PER_PAGE}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((response) => {
        res = response;
      })
      .catch((error) => {
        console.error("Error getting plan attribute table: ", error);
        res = error;
      });
  } catch (error) {
    console.error(error);
    res = error;
  }

  return res;
}
